export const MIN_LOAN_SIMULATION_VALUE = 'min_loan_simulation_value'
export const MIN_LOAN_SIMULATION_VALUE_DEFAULT_VALUE = '20000'
